// Core
import React, { useEffect, useState } from "react";

// Styles
import "./styles.scss";

// Custom layout
import MainLayout from "../../../Layouts/Main";

// Assets
import assets from "../../../Assets/index";

// Custom component
import Chart from "../../../Components/Chart/index";
import DetailsCard from "Components/Common/DetailsCard";
import DropDownBox from "Components/Common/DropDownBox";

//redux
import { useDispatch } from "react-redux";
import { fetchCallReqGraph, fetchCardData, fetchConditionMonitoringGraph, fetchConsultationReqGraph, fetchFARGraph, fetchMaintenanceReqGraph, fetchPurchaseReqGraph } from "../../../Redux/Slices/dashboardSlice";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [cardPeriod, setCardPeriod] = useState("");
  const [callReqPeriod, setCallReqPeriod] = useState("");
  const [maintenanceReqPeriod, setMaintenanceReqPeriod] = useState("");
  const [FARPeriod, setFARPeriod] = useState("");
  const [purchaseReqPeriod, setPurchaseReqPeriod] = useState("");
  const [consultationReqPeriod, setConsultationReqPeriod] = useState("")
  const [conditionMonitoringReqPeriod, setConditionMonitoringReqPeriod] = useState("")
  const [cardData, setCardData] = useState({});
  const [PurchaseReqData, setPurchaseReqData] = useState({});
  const [CallReqData, setCallReqData] = useState({});
  const [MaintenanceReqData, setMaintenanceReqData] = useState({});
  const [FARData, setFARData] = useState({});
  const [consultationReqData, setConsultationReqData] = useState({})
  const [conditionMonitoringReqData, setConditionMonitoringReqData] = useState({})
  const customDropdown = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #B2BEC3",
      borderRadius: "7px",
      padding: "4px",
      boxShadow: "none",
      minHeight: "50px",
      height: "50px",
      cursor: "pointer",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#1F2155"
        : state.isFocused
          ? "#e9ecef"
          : "#fff",
      color: state.isSelected ? "#fff" : "#000",
      padding: 10,
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#1F2155"
          : state.isFocused
            ? "#e9ecef"
            : "#fff",
        color: state.isSelected ? "#fff" : "#000",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#121212",
      padding: "0 8px",
    }),
  };
  const [dropDownCardOptions, setDropDownCardOptions] = useState([
    { value: "weekly", label: "This Week" },
    { value: "lastsixmonth", label: "Last Six Month" },
    { value: "lastyear", label: "Last Year" },
  ]);
  const [purchaseReqOptions, setPurchaseReqOptions] = useState([
    { value: "weekly", label: "This Week" },
    { value: "lastsixmonth", label: "Last Six Month" },
    { value: "lastyear", label: "Last Year" },
  ]);
  const [callReqOptions, setCallReqOptions] = useState([
    { value: "weekly", label: "This Week" },
    { value: "lastsixmonth", label: "Last Six Month" },
    { value: "lastyear", label: "Last Year" },
  ]);
  const [maintenanceReqOptions, setMaintenanceReqOptions] = useState([
    { value: "weekly", label: "This Week" },
    { value: "lastsixmonth", label: "Last Six Month" },
    { value: "lastyear", label: "Last Year" },
  ]);
  const [FAROptions, setFAROptions] = useState([
    { value: "weekly", label: "This Week" },
    { value: "lastsixmonth", label: "Last Six Month" },
    { value: "lastyear", label: "Last Year" },
  ]);
  const [ConsultationReqOptions, setConsultationReqOptions] = useState([
    { value: "weekly", label: "This Week" },
    { value: "lastsixmonth", label: "Last Six Month" },
    { value: "lastyear", label: "Last Year" },
  ]);
  const [conditionMonitoringReqOptions, setConditionMonitoringReqOptions] = useState([
    { value: "weekly", label: "This Week" },
    { value: "lastsixmonth", label: "Last Six Month" },
    { value: "lastyear", label: "Last Year" },
  ]);

  const transformData = (data) => {
    const { labels, datasets } = data; // Destructure labels and datasets

    if (!datasets || datasets.length === 0 || !labels) {
      // console.log(data)
      throw new Error("Invalid data structure");
    }

    // Get the data points from the first dataset
    const values = datasets[0].data;

    return labels.map((label, index) => {
      // Handle dynamic labels (shorten to first 3 characters if months, or keep as-is for weeks)
      const shortName = label.length > 3 ? label.substring(0, 3).toUpperCase() : label.toUpperCase();

      return { name: shortName, value: values[index] || 0 }; // Default value to 0 if missing
    });
  };

  useEffect(() => {
    dispatch(
      fetchCardData({
        data: {
          period: cardPeriod?.value || "weekly",
        },
        callBack: (value) => {
          setCardData(value.data);
        },
      })
    );
  }, [cardPeriod]);

  useEffect(() => {
    dispatch(
      fetchPurchaseReqGraph({
        data: {
          period: purchaseReqPeriod?.value || "weekly",
        },
        callBack: (value) => {
          // console.log(value.data)
          const structuredResp = transformData(value.data)
          // console.log(structuredResp);
          setPurchaseReqData(structuredResp);
        },
      })
    );
  }, [purchaseReqPeriod]);

  useEffect(() => {
    dispatch(
      fetchMaintenanceReqGraph({
        data: {
          period: maintenanceReqPeriod?.value || "weekly",
        },
        callBack: (value) => {
          const structuredResp = transformData(value.data)
          // console.log(structuredResp);
          setMaintenanceReqData(structuredResp);
        },
      })
    );
  }, [maintenanceReqPeriod]);

  useEffect(() => {
    dispatch(
      fetchFARGraph({
        data: {
          period: FARPeriod?.value || "weekly",
        },
        callBack: (value) => {
          const structuredResp = transformData(value.data)
          // console.log(structuredResp);
          setFARData(structuredResp);
        },
      })
    );
  }, [FARPeriod]);

  useEffect(() => {
    dispatch(
      fetchConsultationReqGraph({
        data: {
          period: consultationReqPeriod?.value || "weekly",
        },
        callBack: (value) => {
          const structuredResp = transformData(value.data)
          // console.log(structuredResp);
          setConsultationReqData(structuredResp);
        },
      })
    );
  }, [consultationReqPeriod]);

  useEffect(() => {
    dispatch(
      fetchConditionMonitoringGraph({
        data: {
          period: conditionMonitoringReqPeriod?.value || "weekly",
        },
        callBack: (value) => {
          const structuredResp = transformData(value.data)
          // console.log(structuredResp);
          setConditionMonitoringReqData(structuredResp);
        },
      })
    );
  }, [conditionMonitoringReqPeriod]);

  useEffect(() => {
    dispatch(
      fetchCallReqGraph({
        data: {
          period: callReqPeriod?.value || "weekly",
        },
        callBack: (value) => {
          const structuredResp = transformData(value.data)
          // console.log(structuredResp);
          setCallReqData(structuredResp);
        },
      })
    );
  }, [callReqPeriod]);

  return (
    <MainLayout>
      <div className="dashboardContainer">
        <div className="dashHeader">
          <p className="subHeadings">Users</p>
          <div className="dropDownDiv">
            <DropDownBox
              customStyles={{ customDropdown }}
              placeholder="Select Period"
              options={dropDownCardOptions}
              value={cardPeriod || dropDownCardOptions[0]}
              onChange={(option) => {
                setCardPeriod(option);
              }}
            />
          </div>
        </div>
        <div className="cardContainers">
          <DetailsCard
            image={assets.Icons.noOfCompanies}
            info={cardData?.totalCompanies || "-"}
            title="Total No.of Companies"
            color="#22448F"
          />
          <DetailsCard
            image={assets.Icons.noOfUsers}
            info={cardData?.totalUsers || "-"}
            title="Total No.of Users"
            color="#446EE1"
          />
          <DetailsCard
            image={assets.Icons.activeUsersIcon}
            info={cardData?.activeUsers || "-"}
            title="Active Users"
            color="#4CC5C9"
          />
          <DetailsCard
            image={assets.Icons.inActiveUsers}
            info={cardData?.inactiveUsers || "-"}
            title="Inactive Users"
            color="#E84F44"
          />
        </div>
        <p className="subHeadings">Request Trackings</p>
        <div className="chartContainers">
          <div className="chartContainer">
            <div className="chartHeader">
              <h3>{"No.of Purchase Requests"}</h3>
              <div className="dropDownDiv">
                <DropDownBox
                  customStyles={{ customDropdown }}
                  placeholder="Select Period"
                  options={purchaseReqOptions}
                  value={purchaseReqPeriod || purchaseReqOptions[0]}
                  onChange={(option) => {
                    setPurchaseReqPeriod(option);
                  }}
                />
              </div>{" "}
            </div>
            <Chart chartData={PurchaseReqData} />
          </div>
          <div className="chartContainer">
            <div className="chartHeader">
              <h3>{"Failure Analysis Requests"}</h3>
              <div className="dropDownDiv">
                <DropDownBox
                  customStyles={{ customDropdown }}
                  placeholder="Select Period"
                  options={FAROptions}
                  value={FARPeriod || FAROptions[0]}
                  onChange={(option) => {
                    setFARPeriod(option);
                  }}
                />
              </div>{" "}
            </div>
            <Chart chartData={FARData} />
          </div>
          <div className="chartContainer">
            <div className="chartHeader">
              <h3>{"No.of Maintenance Requests"}</h3>
              <div className="dropDownDiv">
                <DropDownBox
                  customStyles={{ customDropdown }}
                  placeholder="Select Period"
                  options={maintenanceReqOptions}
                  value={maintenanceReqPeriod || maintenanceReqOptions[0]}
                  onChange={(option) => {
                    setMaintenanceReqPeriod(option);
                  }}
                />
              </div>{" "}
            </div>
            <Chart chartData={MaintenanceReqData} />
          </div>
          <div className="chartContainer">
            <div className="chartHeader">
              <h3>{"Call Requests"}</h3>
              <div className="dropDownDiv">
                <DropDownBox
                  customStyles={{ customDropdown }}
                  placeholder="Select Period"
                  options={callReqOptions}
                  value={callReqPeriod || callReqOptions[0]}
                  onChange={(option) => {
                    setCallReqPeriod(option);
                  }}
                />
              </div>{" "}
            </div>
            <Chart chartData={CallReqData} />
          </div>
          <div className="chartContainer">
            <div className="chartHeader">
              <h3>{"Consultation Requests"}</h3>
              <div className="dropDownDiv">
                <DropDownBox
                  customStyles={{ customDropdown }}
                  placeholder="Select Period"
                  options={ConsultationReqOptions}
                  value={consultationReqPeriod || ConsultationReqOptions[0]}
                  onChange={(option) => {
                    setConsultationReqPeriod(option);
                  }}
                />
              </div>{" "}
            </div>
            <Chart chartData={consultationReqData} />
          </div>
          <div className="chartContainer">
            <div className="chartHeader">
              <h3>{"Condition Monitoring Requests"}</h3>
              <div className="dropDownDiv">
                <DropDownBox
                  customStyles={{ customDropdown }}
                  placeholder="Select Period"
                  options={conditionMonitoringReqOptions}
                  value={conditionMonitoringReqPeriod || conditionMonitoringReqOptions[0]}
                  onChange={(option) => {
                    setConditionMonitoringReqPeriod(option);
                  }}
                />
              </div>{" "}
            </div>
            <Chart chartData={conditionMonitoringReqData} />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Dashboard;
